import React from 'react';
import { CommonPageStep } from '..';
import { Button, Grid } from '@mui/material';
import { bool } from 'prop-types';
import { setAppPageStep } from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export interface ForgetEmailElementInterface {
  contactUsButtonClickHandler: () => void;
  emailUsButtonClickHandler: () => void;
}

export const ForgetEmailElement = (): ForgetEmailElementInterface => {
  // Local Variables

  // Hooks

  return {
    contactUsButtonClickHandler() {
      window.open(
        'https://api.whatsapp.com/send/?phone=85230015422&text&app_absent=0',
        '_blank',
      );
    },
    emailUsButtonClickHandler() {
      window.open('mailto:info@bigbangacademyhk.com', '_blank');
    },
  };
};
